import Icon from 'ui/atoms/Icon/Icon';
import * as coreEntities from 'core/store/index';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

function MaterialPreviewDueDate({ material, t }) {
  const deliverAt = material?.deliver_at;
  const language = useSelector((state) => coreEntities.i18n.selectors.getLanguage(state));
  const FORMAT = language === 'en' ? 'YYYY/MM/DD HH:mm' : 'DD/MM/YYYY HH:mm';
  const isExpired = deliverAt ? moment().isAfter(deliverAt) : false;

  return material.isDueDate ? (
    <div className={`material-preview-due-date ${isExpired ? 'expired' : ''} mb-2`}>
      <Icon color={isExpired ? 'red' : 'default'} name={isExpired ? 'warning' : 'calendar'} />

      <span className="text ml-2 mr-2">{`${t('assigments:Due date')}:`}</span>

      <span className="description">{deliverAt ? moment(deliverAt).format(FORMAT) : `(${t('assigments:No due date')})`}</span>

      {isExpired && <span className="status">{t('evaluations:Out of time')}</span>}
    </div>
  ) : null;
}

MaterialPreviewDueDate.propTypes = {
  material: PropTypes.object,
  t: PropTypes.func,
};

export default MaterialPreviewDueDate;
